import {
  ExternalTemplateInformation,
  ExternalTemplateExecuteResult,
  ExternalTemplatesInformation,
  ExternalTemplateCopyResult,
} from "../../../../domain/localhost/items";
import {
  IExternalTemplateCopyResultBean,
  IExternalTemplateInformationBean,
  IExternalTemplateInformationItemBean,
  IExternalTemplateResultBean,
} from "../beans";

export class ExternalTemplateResultTranslator {
  public static toExternalTemplatesInformation(bean: IExternalTemplateInformationBean): ExternalTemplatesInformation {
    if (!bean) { return null; }
    const info = new ExternalTemplatesInformation();
    info.isComplete = !!bean.isComplete;
    info.templates = bean.templates ? bean.templates.map(t => this.toExternalTemplateInformation(t)) : [];
    return info;
  }

  private static toExternalTemplateInformation(bean: IExternalTemplateInformationItemBean): ExternalTemplateInformation {
    const info = new ExternalTemplateInformation();
    info.code = bean.code;
    info.name = bean.name;
    return info;
  }

  public static toExternalTemplateExecuteResult(bean: IExternalTemplateResultBean): ExternalTemplateExecuteResult {
    if (!bean) { return null; }
    const result = new ExternalTemplateExecuteResult();
    result.isComplete = !!bean.isComplete;
    result.registeredId = bean.registeredId;
    result.value = bean.value;
    return result;
  }

  public static toExternalTemplateCopyResult(bean: IExternalTemplateCopyResultBean): ExternalTemplateCopyResult {
    if (!bean) { return null; }
    const result = new ExternalTemplateCopyResult();
    result.isComplete = !!bean.isComplete;
    result.copiedId = bean.copiedId;
    return result;
  }
}
